import { useState, useEffect, useContext, useRef } from 'react';

import { cmnContext } from '../../../../common/CmnContext';
import { SaleListContext } from '../../SaleListContext';


export function SaleDetailBenefit(props: any) {

  const sale = props.sale;

  const isPc = useContext(cmnContext).isPc;
  const benefitColor = useContext(SaleListContext).benefitColor;


  return (
    <>
    {sale.pdf &&
      <a
        href={`/images/sale/pdf/${sale.pdf}?t=${Date.now()}`}
        className='btn'
        style={{
          color: '#fff',
          backgroundColor: benefitColor,
          fontSize: isPc? '100%' : '85%',
          margin: isPc? '0px 15px' : '0px 5px',
          padding: isPc? '7px 20px' : '8px 15px',
          border: 0,
        }}
        target='_blank'
      >
        <i className="fa fa-play-circle" style={{marginRight: 5}}></i>
        特典教材を見る
      </a>
    }
    </>
  );
}